import { HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash-es';
import React, { useContext, useMemo } from 'react';
import Loader from '../../../../../components/Loader';
import { AuthContext } from '../../../../../context/AuthProvider';
import { PluginProps } from '../Plugin';

const toJsxStyleObject = (style: string, width?: string, height?: string) => {
  const obj: Record<string, string> = {};
  const rules = style.split(';');

  for (const rule of rules) {
    const [name, value] = rule.split(':');
    if (value) obj[camelCase(name)] = value;
  }

  if (width) obj['width'] = width;
  if (height) obj['height'] = height;

  return obj;
};

const EmbedBlock = (props: PluginProps) => {
  const { content } = props;
  const { t } = useTranslation();
  const user = useContext(AuthContext);
  const replacedUrl = useMemo(() => {
    if (content.data.url == null) {
      return '';
    }
    if (content.data.url.includes('__FILE_SERVER_TOKEN')) {
      return content.data.url.replaceAll('__FILE_SERVER_TOKEN', user?.token);
    }
    return content.data.url;
  }, [content]);

  if (content.data.drive_url) {
    return (
      <div>
        <iframe
          title={`embed-drive-${content.data.drive_url}`}
          src={content.data.drive_url}
          width="100%"
          height="600px"
          frameBorder={0}
          marginHeight={0}
          marginWidth={0}
          style={{ width: '100%', height: '600px' }}
        >
          Loading...
        </iframe>
      </div>
    );
  }

  return (
    <iframe
      title={`embed-block-${replacedUrl}`}
      src={replacedUrl}
      className={`embed-block${
        content.data.width ? ' embed-block-custom-width' : ''
      }`}
      width={content.data.width ? content.data.width : '100%'}
      height={content.data.height ? content.data.height : '600px'}
      loading={content.data.lazy_loading ? 'lazy' : undefined}
      allow={content.data.allow}
      sandbox={content.data.sandbox}
      referrerPolicy={content.data.referrerpolicy}
      style={
        content.data.style
          ? toJsxStyleObject(
              content.data.style,
              content.data.width,
              content.data.height,
            )
          : {
              width: content.data.width ? content.data.width : '100%',
              height: content.data.height ? content.data.height : '600px',
            }
      }
    >
      <HStack justify="center">
        {t('plugin.embed.loading')} <Loader />
      </HStack>
    </iframe>
  );
};

export default EmbedBlock;
